import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'features/store';
import { getUser } from 'features/auth/auth.slice';
import { StepBlock } from 'components/StepBlock/StepBlock';
import { Button } from 'components/Button/Button';
import { Formik } from 'formik';
import { UserInfoFormSchema } from './UserInfoFormSchema';
import { getDatalists } from 'features/datalist';
import { useUserInfo } from './useUserInfoVM';

export const UserInfo: React.FunctionComponent = () => {
    const user = useSelector((state: RootState) => getUser(state));
    const { datalists } = useSelector(getDatalists);
    const { handleUpdateUser } = useUserInfo();

    return (
        <>
            <Formik
                initialValues={{
                    id: user?.id || 0,
                    role: user?.role || '',
                    firstname: user?.firstname || '',
                    lastname: user?.lastname || '',
                    phone: user?.phone || '',
                    email: user?.email || '',
                    color: user?.color || '',
                    online: user?.online || false,
                    departments: user?.departments || []
                }}
                validationSchema={() => UserInfoFormSchema(datalists || {})}
                onSubmit={async (values, { setSubmitting }) => {
                    handleUpdateUser(values);
                    setSubmitting(false);
                }}
            >
                {({ values, errors, handleChange, handleBlur, handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit} className="form">
                            <StepBlock title="Informations personnelles">
                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Prénom*</label>
                                        <input
                                            type="text"
                                            name="firstname"
                                            placeholder="Maxime"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.firstname}
                                            required
                                        />
                                        {errors.firstname && <p className="error">{errors.firstname}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Nom*</label>
                                        <input
                                            type="text"
                                            name="lastname"
                                            placeholder="Navarro"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.lastname}
                                            required
                                        />
                                        {errors.lastname && <p className="error">{errors.lastname}</p>}
                                    </div>
                                </div>

                                <div className="form-line">
                                    <div className="form-group">
                                        <label>Adresse e-mail</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="maxime.navarro@gmail.com"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.email}
                                        />
                                        {errors.email && <p className="error">{errors.email}</p>}
                                    </div>

                                    <div className="form-group">
                                        <label>Numéro de téléphone*</label>
                                        <input
                                            type="text"
                                            name="phone"
                                            placeholder="06 06 06 06 06"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.phone}
                                            required
                                        />
                                        {errors.phone && <p className="error">{errors.phone}</p>}
                                    </div>
                                </div>

                                {values.role !== 'user' && (
                                    <div className="form-line">
                                        <div className="form-group">
                                            <label>Couleur de l'agenda</label>
                                            <div className="colors">
                                                {Object.entries(datalists?.agenda_colors || {}).map(([key, color]) => (
                                                    <div key={key} className={`color ${values.color === color ? 'selected' : ''}`}>
                                                        <input
                                                            type="radio"
                                                            id={`color-${color}`}
                                                            name="color"
                                                            value={color}
                                                            checked={values.color === color}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            style={{ backgroundColor: color }}
                                                        />
                                                        <label htmlFor={`color-${key}`} style={{ backgroundColor: color }} />
                                                    </div>
                                                ))}
                                            </div>
                                            {errors.color && <p className="error">{errors.color}</p>}
                                        </div>
                                    </div>
                                )}
                                {values.role === 'user' && (
                                    <div className="form-line">
                                        <p>Si vous souhaitez modifier vos informations personnelles, veuillez contacter votre APPV.</p>
                                    </div>
                                )}
                            </StepBlock>
                            <div className="actions-buttons">
                                <Button type="submit" label="Sauvegarder mon profil" />
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </>
    );
};
